export enum OrderSteps {
  APPROVAL = 'approval',
  CANCEL = 'cancel',
  PREPARING = 'preparing',
  ON_WAY = 'on_way',
}
